import { render, staticRenderFns } from "./GerenciaCadastroTiposOcorrencias.vue?vue&type=template&id=14125426"
import script from "./GerenciaCadastroTiposOcorrencias.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroTiposOcorrencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports